import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetFarmList = () => {
  const select = useCallback((data) => {
    return data?.data?.data;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/farm/list",
    },

    {
      queryKey: ["farm-list"],
      select,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );

  return response;
};
